// extracted by mini-css-extract-plugin
module.exports = {"row":"ProductsDashboard_row__2zOzK","col":"ProductsDashboard_col__2LSBr","card":"ProductsDashboard_card__p2d3K"};